(function() {

var _ = ui._;
var products_prepared = {};
var special_attribute_indexes = [];
var isCheckout = location.pathname === ui.url.cart;

ui.cartPaymentTooltipShow = cartPaymentTooltipShow;
ui.productGet             = productGet;
ui.warehousesGet          = warehousesGet;
if(isCheckout) {
  ui.settlements = w.settlements;
  delete w.settlements;
}
ui.loadAdd(onLoad);

function onLoad() {
  ui.cartUI = new CartUI;
}

function Cart() {
  var cartData = {products: {}, total: 0, totals: {}};
  var userFields = [
    'comment',
    'coupon',
    'do_not_call',
    'firstname',
    'lastname',
    'order_id',
    'patronymic',
    'payment_method',
    'products',
    'shipping_address_2',
    'shipping_address_2_id',
    'shipping_city',
    'shipping_city_id',
    'shipping_firstname',
    'shipping_flat',
    'shipping_floor',
    'shipping_floor_raise',
    'shipping_house',
    'shipping_lastname',
    'shipping_lift',
    'shipping_method',
    'shipping_patronymic',
    'shipping_recipient_another',
    'shipping_street',
    'shipping_telephone',
    'telephone',
  ];

  load();

  return {
    add: add,
    cartDataGet: cartDataGet,
    cartDataSet: cartDataSet,
    clear: clear,
    couponCostGet: couponCostGet,
    couponDataGet: couponDataGet,
    cashbackGet: cashbackGet,
    donateGet: donateGet,
    init: init,
    isEmptyGet: isEmptyGet,
    load: load,
    npComissionGet: npComissionGet,
    orderDataGet: orderDataGet,
    productCountGet: productCountGet,
    productTotalGet: productTotalGet,
    productWeightGet: productWeightGet,
    remove: remove,
    shippingCostGet: shippingCostGet,
    sumGet: sumGet,
  };

  function cartDataInit(data) {
    cartData = data;
    ui.localStorage.setItem('cart', JSON.stringify(cartData));
  }

  function cartDataSave(showModal, redirectToCart) {
    function onSuccess(request) {
      cartDataInit(JSON.parse(request.responseText));
      ui.cartUI.update(showModal, redirectToCart);
    }

    ui.ajax('POST', ui.url.cartAdd, JSON.stringify(orderDataGet()), onSuccess, null, null, false);
  }

  function init() {
    cartDataInit(ui.session_data.cart_data);
    delete ui.session_data.cart_data;
  }

  function couponCostGet() {
    return cartData.totals.coupon ? cartData.totals.coupon.value : 0;
  }

  function couponDataGet() {
    return cartData.totals.coupon;
  }

  function cashbackGet(){
    return cashbackCalc(cartData.total);
  }

  function donateGet(){
    var product, res = 0;
    for(var product_id in cartData.products) {
      product = productGet(product_id, true);
      res += cartData.products[product_id] * product.donate;
    }
    return res;
  }

  function load() {
    var savedCart = ui.localStorage.getItem('cart');
    if(savedCart) {
      cartData = JSON.parse(savedCart);
      if(!cartData.products)
        cartData.products = {};
      for(var product_id in cartData.products) {
        product = productGet(product_id, true);
        if(!product)
          delete cartData.products[product_id];
      }
      if(!cartData.total)
        cartData.total = 0;
      if(!cartData.totals)
        cartData.totals = {};
    }
  }

  function npComissionGet() {
    return cartData.totals.novaposhta_pay ? cartData.totals.novaposhta_pay.value : 0;
  }

  function isEmptyGet() {
    return Object.keys(cartData.products).length === 0;
  }

  function productCountGet() {
    var res = 0;
    for(var product_id in cartData.products)
      res += cartData.products[product_id];
    return res;
  }

  function shippingCostGet(){
    return cartData.totals.novaposhta ? cartData.totals.novaposhta.value : 0;
  }

  function sumGet() {
    return cartData.total;
  }

  function productTotalGet() {
    var product, res = 0;
    for(var product_id in cartData.products) {
      product = productGet(product_id, true);
      res += cartData.products[product_id] * product.saleprice;
    }
    return res;
  }

  function productWeightGet() {
    var product, res = 0;
    for(var product_id in cartData.products) {
      product = productGet(product_id, true);
      res += cartData.products[product_id] * product.weight;
    }
    return Math.ceil(res);
  }

  function cartDataGet() {
    return cartData;
  }

  function orderDataGet() {
    var res = {};

    var fields = {
      comment                   : 1,
      coupon                    : 1,
      do_not_call               : 1,
      firstname                 : 1,
      lastname                  : 1,
      patronymic                : 1,
      payment_method            : 1,
      products                  : 1,
      shipping_address_2        : 1,
      shipping_address_2_id     : 1,
      shipping_city             : 1,
      shipping_city_id          : 1,
      shipping_firstname        : 1,
      shipping_flat             : 1,
      shipping_floor            : 1,
      shipping_floor_raise      : 1,
      shipping_house            : 1,
      shipping_lastname         : 1,
      shipping_lift             : 1,
      shipping_method           : 1,
      shipping_patronymic       : 1,
      shipping_recipient_another: 1,
      shipping_street           : 1,
      shipping_telephone        : 1,
      telephone                 : 1
    };
    for(var i = 0, name, names = Object.keys(cartData); i < names.length; i++) {
      name = names[i];
      if(fields[name])
        res[name] = cartData[name];
    }
    return res;
  }

  function add(product_id, showModal, redirectToCart) {
    var product = productGet(product_id, true);
    if(!product || (product.instock != 1))
      delete cartData.products[product_id];
    else {
      if(!cartData.products[product_id])
        cartData.products[product_id] = 0;
      cartData.products[product_id]++;

      if(cartData.products[product_id] === 1) {
        var item = {
          id: product_id + ui.mpsub,
          google_business_vertical: 'retail'
        };
        var category = ui.category_id_cart && product_data.category_names[ui.category_id_cart] ? product_data.category_names[ui.category_id_cart][0] : (ui.category_id_cart === 0 ? 'Search' : '');
        if(category)
          item.item_category = category;
        dataLayer.push({
          event: 'add_to_cart',
          value: product.saleprice,
          items: [item]
        });
      }
    }

    cartDataSave(showModal, redirectToCart);
  }

  function clear() {
    cartData.products = {};
    cartDataSet('order_id', undefined);
  }

  function remove(product_id) {
    delete cartData.products[product_id];
    cartDataSave();
  }

  function cartDataSet(name, value) {
    if(name.substring(0, 9) === 'products[') {
      var product_id = name.substring(9, name.indexOf(']'));
      if(value == 0)
        delete cartData.products[product_id];
      else
        cartData.products[product_id] = value;
    } else {
      var val = cartData[name];
      if(!value)
        delete cartData[name];
      else
        cartData[name] = value;
    }

    cartDataSave();
  }
}

function CartUI() {
  var telephone_pattern = '[+38 0]{5}[0-9]{2} [0-9]{3} [0-9]{2} [0-9]{2}';
  var SVG_BAG = '<svg width="20" height="20" aria-hidden="true"><use href="#svg-icon-shopping-bag"/></svg>';
  var SVG_X = '<svg width="24" height="24" aria-hidden="true"><use href="#svg-icon-x"/></svg>';
  var SVG_CHEVRON_RIGHT = '<svg width="20" height="20" class="group-hover:translate-x-1 transition-transform" aria-hidden="true"><use href="#svg-icon-chevron-right"/></svg>';
  var SVG_CHEVRON_LEFT = '<svg width="16" height="16" class="group-hover:-translate-x-1 transition-transform" aria-hidden="true"><use href="#svg-icon-chevron-left"/></svg>';
  var SVG_ALERT = '<svg width="14" height="14" class="shrink-0" aria-hidden="true"><use href="#svg-icon-circle-alert"/></svg>';
  var SVG_INFO = '<svg width="12" height="12" class="text-blue-500" aria-hidden="true"><use href="#svg-icon-info"/></svg>';
  var SVG_PHONE = '<svg width="12" height="12" class="text-gray-400" aria-hidden="true"><use href="#svg-icon-phone-call"/></svg>';
  var hotlineHE = d.querySelector('.binct-phone-number-1');
  var hotlineText = hotlineHE ? hotlineHE.textContent.trim() : '';
  var hotlineHTML = hotlineText
    ? '<div class="bg-gray-50/50 px-8 py-3 flex items-center justify-center gap-2 border-t border-gray-100">' +
        SVG_PHONE +
        '<span class="text-[10px] text-gray-400 font-bold uppercase tracking-wider">' + ui.lang.text_hotline + ': ' + hotlineText + '</span>' +
      '</div>'
    : '';
  var offerLink = '<a href="' + ui.url.public_offer + '" target="_blank" class="mx-1 text-gray-600 underline hover:text-black transition-colors font-semibold">' + ui.lang.text_public_offer + '</a>';
  var cartHTML =
    '<form id="cart-user" class="cart-user cart-modal-form" onchange="ui.cartUI.onChange(event)">' +
      '<div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">' +
        '<div class="flex items-center gap-3">' +
          '<div class="bg-brand p-2 rounded-xl flex items-center justify-center text-brand-text">' + SVG_BAG + '</div>' +
          '<h2 class="text-2xl font-black uppercase tracking-tight m-0">' + ui.lang.text_cart + '</h2>' +
        '</div>' +
        '<button type="button" onclick="ui.modalClose()" class="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-black bg-transparent border-0 cursor-pointer" aria-label="Close">' + SVG_X + '</button>' +
      '</div>' +
      '<div class="cart-modal-body px-8 py-6">' +
        '<div id="cart-products" class="cart-modal-products overflow-y-auto pr-2 space-y-6 custom-scrollbar mb-4"></div>' +
        '<div class="cart-modal-footer-area pt-4 border-t border-gray-100">' +
          '<div class="flex items-center justify-between mb-4">' +
            '<span class="text-gray-500 font-medium">' + ui.lang.text_price_total + ':</span>' +
            '<span id="cart-total" class="text-3xl font-black"></span>' +
          '</div>' +
          '<a href="' + ui.url.cart + '" class="cart-modal-checkout-btn w-full bg-brand hover:bg-brand-hover text-brand-text font-black py-4 rounded-2xl transition-all flex items-center justify-center gap-2 group active:scale-[0.98] text-base uppercase tracking-wider mb-4 no-underline">' +
            '<span>' + ui.lang.button_checkout + '</span>' + SVG_CHEVRON_RIGHT +
          '</a>' +
          '<div class="cart-text-or">' + ui.lang.text_or + '</div>' +
          '<div class="bg-gray-50 p-4 rounded-2xl border border-gray-100 mb-4">' +
            '<div class="flex items-center gap-2 mb-2">' + SVG_ALERT +
              '<p class="text-[11px] font-bold uppercase tracking-tight leading-tight m-0">' + ui.lang.text_telephone_notice + '</p>' +
            '</div>' +
            '<div class="flex gap-2">' +
              '<input id="cart-telephone" oninput="ui.cartUI.onInputTelephone(event)" class="cart-telephone cart-modal-tel-input flex-1 bg-white border border-gray-200 rounded-xl py-2.5 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-brand/50 focus:border-brand transition-all font-medium" name="telephone" value="+38" data="0XXXXXXXXX" type="tel" pattern="' + telephone_pattern + '" required>' +
              '<button type="button" id="cart-click1" onclick="ui.cartUI.checkout()" class="bg-black hover:bg-gray-800 text-white px-5 py-2.5 rounded-xl font-black text-[11px] uppercase tracking-wider transition-all active:scale-95 whitespace-nowrap border-0 cursor-pointer">' + (ui.lang.button_1click_short || ui.lang.button_checkout1) + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="space-y-3 px-1 mb-6">' +
            '<div class="flex items-start gap-2.5">' +
              '<div class="mt-1 bg-blue-50 p-1 rounded-md shrink-0">' + SVG_INFO + '</div>' +
              '<div class="text-[11px] leading-relaxed text-gray-500 font-medium">' + ui.lang.text_manager_message_cart + '</div>' +
            '</div>' +
            '<div class="text-[10px] text-center text-gray-400 leading-normal">' + ui.lang.text_offer_agree + offerLink + '.</div>' +
          '</div>' +
          '<button type="button" onclick="ui.modalClose()" class="w-full flex items-center justify-center gap-2 text-gray-600 hover:text-black font-bold py-2 transition-all text-xs uppercase tracking-wider group bg-transparent border-0 cursor-pointer">' +
            SVG_CHEVRON_LEFT + '<span>' + ui.lang.button_shopping + '</span>' +
          '</button>' +
        '</div>' +
      '</div>' +
      hotlineHTML +
    '</form>';
  var successHTML =
      '<div class="cart-success-box">' +
        '<div class="cart-success-icon-box"><svg class="cart-success-icon"><use href="#svg-icon-cart-check"></svg></div>' +
        '<div class="cart-success-title1">' + ui.lang.text_success_title1 + '</div>' +
        '<div class="cart-success-title2"><span><svg class="cart-success-icon-check"><use href="#svg-icon-check"></svg> ' + ui.lang.text_success_title2 + '!</span></div>' +
        '<div class="cart-success-text">' + ui.lang.text_success_text1 + '</div>' +
        ( ui.has_cashback_url ?
        '<div class="cart-success-cashback">' +
          '<div>' + ui.lang.text_success_cashback + '</div>' +
          '<div><a href="' + ui.url.cashback + '" target="_blank" class="email">' + ui.lang.text_success_details + '</a></div>' +
        '</div>' : ''
        ) +
        '<div class="text-center">' +
          '<div onclick="ui.modalClose()" class="cart-success-btn">' + ui.lang.text_home + '</div>' +
        '</div>' +
      '</div>';

  var cart = new Cart;
  var $cartProductCount = _('#cart-product-count');
  var warehouses = [];
  _('#telephone').attr('pattern', telephone_pattern);
  if(isCheckout) {
    new autocomplete('shipping_city');
    new autocomplete('shipping_address_2');
    w.addEventListener('hashchange', onHashChange, false);
  }
  update(false);
  ui.afterSessionInitAdd(init);
  w.addEventListener('storage', storageChanged);
  return {
    add: add,
    checkout: checkout,
    couponDel: couponDel,
    orderFail: orderFail,
    orderFinish: orderFinish,
    orderProcess: orderProcess,
    quantitySet: quantitySet,
    remove: remove,
    shippingCityIDGet: shippingCityIDGet,
    update: update,
    onChange: onChange,
    onFocusIn: onFocusIn,
    onInputTelephone: onInputTelephone,
    shippingTab: shippingTab
  };

  function init() {
    cart.init();
    update(false);
  }

  function add(event, product_id, redirectToCart) {
    event.preventDefault();
    event.stopPropagation();
    cart.add(product_id, true, redirectToCart);
  }

  function checkout() {
    if(cart.isEmptyGet())
      ui.messageShow(ui.lang.text_no_products_in_cart, 'warning');
    else
    if(formValidate())
      orderProcess();
  }

  function couponDel(event) {
    cart.cartDataSet('coupon', '');
  }

  function orderFinish(data) {
    function confirmed(request) {
      var res = JSON.parse(request.responseText);
      orderSuccess(res.html);
    }

    ui.ajax('POST', ui.url.orderFinish, data ? JSON.stringify(data) : '', confirmed);
  }

  function orderFail(message) {
    var order_id = cart.cartDataGet().order_id;
    ui.modalOpenContent(
      '<div class="text-center">' + ui.lang.text_fail_text + (message ? '<br>' + message : '') + '</div>',
      ui.lang.text_fail_title.replace('order_id', order_id)
    );
  }

  function orderSuccess(html) {
    function reload() {
      location.href = '/';
    }
    var html = successHTML.replaceAll('{order_id}', cart.cartDataGet().order_id);
    cart.clear();
    update(false);
    ui.modalOpenContent(html, '', undefined, undefined, reload);
  }

  function orderModalBeforeClose() {
    function loaded(request) {
      var obj = JSON.parse(request.responseText);
      if(obj.order_status_id != 0)
        if(obj.order_status_id == 16/*payed*/)
          orderSuccess();
        else
          orderFail();
    }
    var hash = location.hash;
    if(hash === '#success')
      orderSuccess();
    else
    if(hash === '#fail')
      orderFail();
    else
    if(hash === '')
      ui.ajax('POST', ui.url.orderCheck + '?order_id=' + cart.cartDataGet().order_id, '', loaded);
  }

  function orderProcess() {
    function orderAdded(request) {
      var res = JSON.parse(request.responseText);
      var cartData = cart.cartDataGet();
      cart.cartDataSet('order_id', res.order_id);

      if(w.dataLayer) {
        var purchase = {
          event: 'purchase',
          ecommerce: {
            currency      : 'UAH',
            items         : [],
            shipping      : cart.shippingCostGet(),
            transaction_id: res.order_id,
            value         : cart.productTotalGet(),
          }
        };
        var purchase2 = {
          event: 'purchase2',
          items: [],
          value: cart.productTotalGet()
        };

        var cartProducts = cartData.products, product;
        for(var product_id in cartProducts) {
          product = productGet(product_id, true);
          purchase.ecommerce.items.push({
            affiliation  : location.hostname,
            item_category: product.category,
            item_id      : product.product_id,
            item_name    : product.title,
            price        : product.saleprice,
            quantity     : cartProducts[product_id],
          });
          purchase2.items.push({
            id: product.product_id + ui.mpsub,
            google_business_vertical: 'retail'
          });
        }

        dataLayer.push({ecommerce: null});
        dataLayer.push({
          event : 'date_for_order',
          number: '+38' + cartData.telephone
        });
        dataLayer.push(purchase);
        dataLayer.push(purchase2);
      }

      if(['bank_account', 'cod'].indexOf(cartData.payment_method) !== -1)
        orderSuccess();
      else
      if(cartData.payment_method === 'paylater')
        ui.modalOpenContent(res.html, res.title, true, false);
      else
      if(cartData.payment_method.substr(0, 9) === 'wayforpay')
        ui.wayforpay.orderProcess(res.fields);
      else
        ui.modalOpenContent('<iframe id="paymentFrame" src="' + res.action + '"></iframe>',
          '', true, true, orderModalBeforeClose);
    }

    if(!isCheckout)
      cart.cartDataSet('payment_method', 'cod');
    ui.ajax('POST', ui.url.orderAdd, JSON.stringify(cart.orderDataGet()), orderAdded);
  }

  function quantitySet(product_id, count) {
    var he = _('#products[' + product_id + ']').el;
    var value = he.value;
    he.stepUp(count);
    if(value !== he.value)
      he.dispatchEvent(new Event('change', {bubbles: true}));
  }

  function remove(product_id) {
    cart.remove(product_id);
  }

  function shippingCityIDGet() {
    return cart.cartDataGet().shipping_city_id;
  }

  function storageChanged(event) {
    cart.load();
    update(false);
  }

  function update(showModal, redirectToCart) {
    if(isCheckout) {
      var cartData = cart.cartDataGet();
      var couponCost = cart.couponCostGet();
      var couponData = cart.couponDataGet();
      var shippingCost = cart.shippingCostGet();
      var cartIsEmpty = cart.isEmptyGet();
      _('#cart-totals-box').toggleClass('cart-empty', cartIsEmpty);
      _('#shipping_address_1_box').toggleClass('hidden', cartData.shipping_method !== 'novaposhta_flat');
      _('#shipping_address_2_box').toggleClass('hidden', cartData.shipping_method !== 'novaposhta_warehouse');
      var shippingTabs = d.querySelectorAll('.shipping-tab');
      for(var ti = 0; ti < shippingTabs.length; ti++) {
        var isActive = shippingTabs[ti].getAttribute('data-value') === cartData.shipping_method;
        shippingTabs[ti].classList.toggle('bg-white', isActive);
        shippingTabs[ti].classList.toggle('shadow', isActive);
        shippingTabs[ti].classList.toggle('text-dark', isActive);
        shippingTabs[ti].classList.toggle('text-gray-500', !isActive);
      }
      let shippingInput = d.getElementById('shipping_method_input');
      if (shippingInput) {
        shippingInput.value = cartData.shipping_method;
      }
      _('#cart-shipping-cost-box').toggleClass('hidden', !cartData.totals.novaposhta);
      _('#cart-shipping-cost').text(ui.priceFormat(shippingCost));
      _('#coupon').toggleClass('hidden', !!couponData);
      _('#cart-coupon-add').toggleClass('hidden', !!couponData);
      _('#cart-coupon-btn-del').toggleClass('hidden', !couponData);
      _('#cart-coupon-cost').toggleClass('hidden', !couponData).text(ui.priceFormat(couponCost));
      _('#cart-coupon-info').html(couponData ? '<b>' + cartData.coupon.toUpperCase() + '</b>: ' + cartData.totals.coupon.title : '');
      _('#checkout-cart-continue').toggleClass('hidden', !cartIsEmpty);
      _('#shipping-recipient-another-box').toggleClass('hidden', !cartData.shipping_recipient_another);
      if(cartData.shipping_recipient_another)
        _('#shipping_telephone').attr('pattern', telephone_pattern);
      else
        _('#shipping_telephone').attrR('pattern');
      _('#cart-weight').text(ui.weightFormat(cart.productWeightGet()));
    } else {
      $cartProductCount.text(cart.productCountGet());
      var $mob = _('#cart-product-count-mobile');
      if($mob.el) $mob.text(cart.productCountGet());
      if(redirectToCart) {
        ui.modalClose();
        setTimeout(function() { location.href = ui.url.cart; }, 0);
      } else {
        if(showModal/* && !ui.modalIsOpened()*/)
          ui.modalOpenContent(cartHTML, ui.lang.text_cart);
      }
    }
    htmlProducts();
    updateCartButtons();
    _('#cart-total').text(ui.priceFormat(cart.productTotalGet()));
    _('#cart-commission').text(ui.priceFormat(cart.npComissionGet()));
    var totalFormatted = ui.priceFormat(cart.sumGet());
    _('#cart-total2').text(totalFormatted);
    var $totalMob = _('#cart-total2-mobile');
    if($totalMob.el) $totalMob.text(totalFormatted);
    _('#cart-donate').text(ui.priceFormat(cart.donateGet()));
    _('#cart-cashback').text(ui.priceFormat(cart.cashbackGet()));
    requiredFieldSet();
    userDataValuesSet();
  }

  function userDataValuesSet() {
    var formHE = d.getElementById('cart-user');
    if(!formHE)
      return;
    var cartData = cart.cartDataGet();
    for(var i = 0, value, inputHE; i < formHE.length; i++) {
      inputHE = formHE[i];
      if(inputHE.name) {
        value = cartData[inputHE.name] || '';
        switch(inputHE.type) {
        case 'tel':
          inputHE.value = telephoneFormat(value);
          break;
        case 'email':
        case 'hidden':
        case 'number':
        case 'text':
        case 'textarea':
          inputHE.value = value;
          break;
        case 'select':
        case 'select-one':
          for(var j = 0; j < inputHE.length; j++)
            if(inputHE[j].value == value) {
              inputHE[j].selected = true;
              break;
            }
          break;
        case 'checkbox':
          inputHE.checked = !!value;
          break;
        case 'radio':
          inputHE.checked = value === inputHE.value;
          break;
        default:
          throw new Error('userDataValuesSet: not handled input type ' + inputHE.type);
        }
      }
    }
  }

  function requiredFieldSet() {
    var cartData = cart.cartDataGet();
    var fields = {
      comment                   : false,
      coupon                    : false,
      shipping_address_2        : false,
      shipping_city             : false,
      firstname                 : false,
      shipping_firstname        : false,
      shipping_flat             : false,
      shipping_floor            : false,
      shipping_floor_raise      : false,
      shipping_house            : false,
      lastname                  : false,
      shipping_lastname         : false,
      shipping_lift             : false,
      patronymic                : false,
      shipping_patronymic       : false,
      shipping_street           : false,
      shipping_telephone        : !!cartData.shipping_recipient_another,
      telephone                 :  true
    };
    if(cartData.do_not_call) {
      var namePrefix = cartData.shipping_recipient_another ? 'shipping_' : '';
      fields[namePrefix + 'firstname']   = true;
      fields[namePrefix + 'lastname']    = true;
      fields['shipping_city']        = true;
      if(cartData.shipping_method === 'novaposhta_warehouse')
        fields['shipping_address_2'] = true;
      else {
        fields[namePrefix + 'patronymic'] = true;
        fields['shipping_street']    = true;
        fields['shipping_house']     = true;
        fields['shipping_floor']     = cartData.shipping_floor_raise;
      }
    }

    var names = Object.keys(fields);
    for(var i = 0; i < names.length; i++) {
      var name = names[i];
      var inputHE = d.getElementById(name);
      if(!inputHE)
        continue;
      if(fields[name]) {
        inputHE.setAttribute('required', 'required');
        for(var j = 0; j < inputHE.labels.length; j++)
          inputHE.labels[j].classList.add('required2');
      } else {
        inputHE.removeAttribute('required');
        for(var j = 0; j < inputHE.labels.length; j++)
          inputHE.labels[j].classList.remove('required2');
      }
    }
  }

  function shippingTab(btn) {
    let value = btn.getAttribute('data-value');
    let input = d.getElementById('shipping_method_input');
    if (input) {
      input.value = value;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    var tabs = d.querySelectorAll('.shipping-tab');
    for(var i = 0; i < tabs.length; i++) {
      if(tabs[i] === btn) {
        tabs[i].classList.add('bg-white', 'shadow', 'text-dark');
        tabs[i].classList.remove('text-gray-500');
      } else {
        tabs[i].classList.remove('bg-white', 'shadow', 'text-dark');
        tabs[i].classList.add('text-gray-500');
      }
    }
  }

  function onChange(event) {
    var input = event.target;
    var name = input.name || input.id;
    if(!name || (name === 'shipping_city') || (name === 'shipping_address_2'))
      return;
    var value;
    switch(input.type){
    case 'tel':
      value = telephoneClean(input.value);
      break;
    case 'email':
    case 'hidden':
    case 'number':
    case 'select':
    case 'select-one':
    case 'text':
    case 'textarea':
      value = input.value;
      break;
    case 'checkbox':
      value = input.checked;
      break;
    case 'radio':
      if(!input.checked)
        return;
      value = input.value;
      break;
    default:
      throw new Error('onChange: not handled input type ' + input.type);
    }
    cart.cartDataSet(name, value);
  }

  function onFocusIn(event) {
    var hes = d.querySelectorAll('.focused');
    for(var i = 0; i < hes.length; i++)
      _(hes[i]).toggleClass('focused', false);
    _(event.target).parent().toggleClass('focused', true);
  }

  function onInputTelephone(event) {
    var he = event.target;
    var tel = telephoneFormat(he.value);
    if(he.value !== tel)
      he.value = tel;
  }

  function updateCartButtons() {
    var products = cart.cartDataGet().products;
    var containers = d.querySelectorAll('[data-cart-btn]');
    for(var i = 0; i < containers.length; i++) {
      var pid = containers[i].getAttribute('data-cart-btn');
      var inCart = products[pid] !== undefined;
      var addBtns = containers[i].getElementsByClassName('cart-add-only');
      var incartBtns = containers[i].getElementsByClassName('cart-in-cart-only');
      for(var j = 0; j < addBtns.length; j++)
        addBtns[j].classList.toggle('!hidden', inCart);
      for(var j = 0; j < incartBtns.length; j++)
        incartBtns[j].classList.toggle('!hidden', !inCart);
    }
  }

  function htmlProducts() {
    function isWished(product_id) {
      return ui.session_data && ui.session_data.wish && ui.session_data.wish.indexOf(+product_id) !== -1;
    }
    function heartSVG(filled) {
      return '<svg width="14" height="14" aria-hidden="true"><use href="#svg-icon-heart-line"/></svg>';
    }
    function renderModalCard(product, qty) {
      var wished = isWished(product.product_id);
      var heartCls = wished
        ? 'cart-modal-heart absolute -top-2 -right-2 p-1.5 rounded-full shadow-md transition-all duration-300 bg-red-50 text-red-500 scale-110 border-0 cursor-pointer'
        : 'cart-modal-heart absolute -top-2 -right-2 p-1.5 rounded-full shadow-md transition-all duration-300 bg-white text-gray-300 hover:text-gray-400 border-0 cursor-pointer';
      var priceHTML = product.price_old && product.price_old > product.saleprice
        ? '<span class="text-[10px] font-bold text-gray-400 line-through decoration-red-400/50 leading-none mb-1">' + ui.priceFormat(product.price_old) + '</span>' +
          '<span class="text-lg font-black leading-none text-red-600">' + ui.priceFormat(product.saleprice) + '</span>'
        : '<span class="text-lg font-black leading-none text-gray-900">' + ui.priceFormat(product.saleprice) + '</span>';
      return '<div class="flex gap-6 items-start pb-6 border-b border-gray-50 last:border-0 last:pb-0">' +
          '<div class="relative group shrink-0">' +
            '<a href="' + product.href + '" class="block w-20 h-20 bg-gray-50 rounded-2xl flex items-center justify-center p-2 border border-gray-100">' +
              '<img src="' + product.image + '" alt="' + (product.title || '')/*.replace(/"/g, '&quot;')*/ + '" class="mix-blend-multiply object-contain w-full h-full">' +
            '</a>' +
            '<button type="button" class="' + heartCls + ' wish-' + product.product_id + '" onclick="ui.wishToggle(event, ' + product.product_id + ')" aria-label="wish">' + heartSVG(wished) + '</button>' +
          '</div>' +
          '<div class="flex-1 min-w-0">' +
            '<div class="flex items-start justify-between gap-2 mb-2">' +
              '<a href="' + product.href + '" class="block font-bold text-sm leading-tight line-clamp-2 text-gray-900 hover:text-brand no-underline">' + product.title + '</a>' +
              '<button type="button" title="' + (ui.lang.button_delete || '') + '" class="shrink-0 p-1 -mt-0.5 -mr-1 text-gray-300 hover:text-red-500 transition-colors bg-transparent border-0 cursor-pointer" onclick="ui.cartUI.remove(' + product.product_id + ')" aria-label="' + (ui.lang.button_delete || 'delete') + '">' +
                '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-trash"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="flex items-center justify-between gap-2">' +
              '<div class="flex items-center bg-gray-100 rounded-lg p-0.5">' +
                '<button type="button" class="p-1 hover:bg-white rounded-md transition-all shadow-sm active:scale-95 text-gray-500 bg-transparent border-0 cursor-pointer" onclick="ui.cartUI.quantitySet(' + product.product_id + ', -1)" aria-label="-">' +
                  '<svg width="14" height="14" aria-hidden="true"><use href="#svg-icon-minus"/></svg>' +
                '</button>' +
                '<input type="number" id="products[' + product.product_id + ']" min="1" value="' + qty + '" readonly class="w-8 text-center font-bold text-xs bg-transparent border-0 outline-none">' +
                '<button type="button" class="p-1 hover:bg-white rounded-md transition-all shadow-sm active:scale-95 text-gray-500 bg-transparent border-0 cursor-pointer" onclick="ui.cartUI.quantitySet(' + product.product_id + ', 1)" aria-label="+">' +
                  '<svg width="14" height="14" aria-hidden="true"><use href="#svg-icon-plus"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="text-right flex flex-col items-end shrink-0">' + priceHTML + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }
    function renderCompactCard($box, product, qty) {
      _('div').appendTo($box).attr('class', 'flex gap-3 items-start border-b border-gray-100 pb-3 last:border-0').append(
        _('img').attr(
          'class', 'w-16 h-16 bg-gray-100 rounded-lg object-contain shrink-0',
          'src', product.image
        ),
        _('div').attr('class', 'flex-1 min-w-0').append(
          _('a').attr('class', 'text-sm font-medium hover:text-brand line-clamp-2 leading-snug mb-1', 'href', product.href).text(product.title),
          _('div').attr('class', 'flex justify-between items-center mt-2').append(
            _('div').attr('class', 'flex items-center border border-gray-200 rounded-lg h-7').append(
              _('button').attr(
                'class', 'w-7 h-full flex items-center justify-center text-gray-500 hover:text-dark',
                'onclick', 'ui.cartUI.quantitySet(' + product.product_id + ', -1)'
              ).text('−'),
              _('input').attr(
                'type', 'number',
                'id', 'products[' + product.product_id + ']',
                'value', qty,
                'readonly', 1,
                'min', 1,
                'class', 'w-8 text-center text-xs font-bold text-dark'
              ),
              _('button').attr(
                'class', 'w-7 h-full flex items-center justify-center text-gray-500 hover:text-dark',
                'onclick', 'ui.cartUI.quantitySet(' + product.product_id + ', 1)'
              ).text('+')
            ),
            _('div').attr('class', 'font-bold text-sm').text(ui.priceFormat(product.saleprice))
          )
        ),
        _('button').attr(
          'class', 'text-gray-300 hover:text-accent transition px-1',
          'onclick', 'ui.cartUI.remove(' + product.product_id + ')'
        ).append(
          _('i').attr('class', 'fa fa-times')
        )
      );
    }
    function lprocess(id, useModalLayout) {
      var $productsBox = _(id).html('');
      if(!$productsBox.el)
        return;
      var cartProducts = cart.cartDataGet().products;
      if(cart.isEmptyGet()) {
        _('div').appendTo($productsBox).text(ui.lang.text_cart_empty).attr('class', 'checkout-products-empty text-center text-gray-500 py-8');
        return;
      }
      for(var product_id in cartProducts) {
        var product = productGet(product_id, true);
        if(useModalLayout)
          $productsBox.el.insertAdjacentHTML('beforeend', renderModalCard(product, cartProducts[product_id]));
        else
          renderCompactCard($productsBox, product, cartProducts[product_id]);
      }
    }
    lprocess('#cart-products', !isCheckout);
    lprocess('#cart-products-mob', false);
  }
}

function autocomplete(inputID) {
  function onClick(event) {
    if(event.target === itemsHE)
      return;
    if(event && event.preventDefault)
      event.preventDefault();
    var index = event.target.getAttribute('data-index');
    var item = list[index];
    if(item) {
      inputHE.value = item[2];
      inputHE2.value = item[0];
    }
    inputHE2.dispatchEvent(new Event('change', {bubbles: true}));
    _(inputHE).parent().toggleClass('focused', false);
  }

  function onKeyDown(event) {
    function addActive(count) {
      if(!itemsHE.children.length)
        return;
      if(itemsHE.children[currentFocus])
        itemsHE.children[currentFocus].classList.remove('autocomplete-active');
      currentFocus += count;
      if(currentFocus >= itemsHE.children.length)
        currentFocus = 0;
      else
      if(currentFocus < 0)
        currentFocus = itemsHE.children.length - 1;
      var itemHE = itemsHE.children[currentFocus];
      itemHE.classList.add('autocomplete-active');
      itemsHE.scroll({top: itemHE.offsetTop, behavior: 'smooth'});
    }

    var code = event.keyCode;
    if([13, 38, 40].indexOf(code) === -1)
      return;
    event.preventDefault();
    if(code === 40/*down*/)
      addActive(1);
    else
    if(code === 38/*up*/)
      addActive(-1);
    else
    if((code === 13/*enter*/) && itemsHE.children.length && (currentFocus > -1))
      onClick({'target': itemsHE.children[currentFocus]});
  }

  function settlement() {
    function lsort(id1, id2) {
      var item1 = list[id1], item2 = list[id2];
      var res = item2[5] - item1[5];
      if(res === 0)
        res = item2[1] > item1[1] ? -1 : 1;
      return res;
    }

    var value = valueGet();
    currentFocus = -1;
    if(!list)
      return;
    var keys = Object.keys(list);
    var ids = [];
    for(var i = 0; i < keys.length; i++) {
      item = list[keys[i]];
      if(!item || (value && (item[1].indexOf(value) === -1)))
        continue;
      region = ui.settlements.region[item[3]];
      if(!value && region)
        continue;
      ids.push(keys[i]);
    }

    ids.sort(lsort);

    var fragHE = d.createDocumentFragment(), itemHE, item, region, area;
    for(var i = 0; i < ids.length; i++) {
      item = list[ids[i]];
      region = ui.settlements.region[item[3]];
      area = ui.settlements.area[item[4]] + ' ' + ui.lang.text_area;
      itemHE = fragHE.appendChild(d.createElement('div'));
      itemHE.textContent = item[2] + ' (' + (region ? region + ', ' : '') + area + ')';
      itemHE.setAttribute('data-index', ids[i]);
      if(item[5] === 0)
        itemHE.classList.add('autocomplete-empty');
    }
    itemsHE.innerHTML = '';
    itemsHE.appendChild(fragHE);
    clearTimeout(onInputTimeout);
    onInputTimeout = null;
  }

  var onInputTimeout;

  function valueGet() {
    return inputHE.value.toLowerCase();
  }

  function onInput(event) {
    itemsHE.scrollTop = 0;
    if(isSettlement) {
      if(onInputTimeout)
        clearTimeout(onInputTimeout);
      onInputTimeout = setTimeout(settlement, 300);
    } else {
      itemsHE.innerHTML = '';
      var value = valueGet();
      currentFocus = -1;
      var itemHE, item;
      if(list) {
        var keys = Object.keys(list);
        for(var i = 0; i < keys.length; i++) {
          item = list[keys[i]];
          if(item[1].indexOf(value) === -1)
            continue;
          itemHE = itemsHE.appendChild(d.createElement('div'));
          itemHE.textContent = item[2];
          itemHE.setAttribute('data-index', i);
        }
      }
    }
  }

  function onFocus(event) {
    function loaded(warehouses) {
      list = warehouses;
      onInput();
    }

    if(isSettlement)
      onInput();
    else
      ui.warehousesGet(loaded);
  }

  function clear(event) {
    event.stopPropagation();
    inputHE.value = '';
    inputHE2.value = '';
    inputHE2.dispatchEvent(new Event('change', {bubbles: true}));
  }

  function settlementsLoaded() {
    if(ui.settlements)
      list = ui.settlements.settlement;
    else
      setTimeout(settlementsLoaded, 100);
  }

  var isSettlement = inputID === 'shipping_city';
  var list;
  var currentFocus = -1;
  var inputHE = d.getElementById(inputID);
  var inputHE2 = d.getElementById(inputID + '_id');
  inputHE.addEventListener('input', onInput);
  inputHE.addEventListener('focus', onFocus);
  inputHE.addEventListener('keydown', onKeyDown);
  var itemsHE = inputHE.parentNode.appendChild(d.createElement('div'));
  itemsHE.setAttribute('class', 'autocomplete-items');
  itemsHE.addEventListener('click', onClick);
  var btnHE = inputHE.parentNode.appendChild(d.createElement('div'));
  btnHE.className = 'fa fa-times-circle-o';
  btnHE.addEventListener('click', clear);
  if(isSettlement)
    settlementsLoaded();
}

function cartPaymentTooltipShow(event) {
  event.preventDefault();
  event.stopPropagation();
  var description = event.target.getAttribute('data-tip');
  if(!description) {
    var type = event.target.getAttribute('data');
    if(type)
      description = ui.lang[type + '_description'];
  }
  if(description)
    ui.tooltipShow(event, description, 'tooltip-box-cart');
}

function formValidate() {
  var isValid = true;
  var formHE = d.getElementById('cart-user');
  for(var i = 0, he; i < formHE.length; i++) {
    he = formHE[i];
    if(he.checkValidity())
      continue;
    isValid = false;
    if(he.name === 'telephone')
      ui.messageShow(ui.lang.text_phone_error, 'error');
    else
      ui.messageShow(ui.lang.text_input_required + ' ' + he.getAttribute('data'), 'error');
  }
  return isValid;
}

function onHashChange() {
  if(['#fail', '#success'].indexOf(location.hash) !== -1) {
    ui.modalClose();
    ui.hashClear();
  }
}

function special_attribute_indexes_get() {
  if(special_attribute_indexes.length === 0) {
    for(var i = 0, l = product_data.attributes.length, attribute; i < l; i++) {
      attribute = product_data.attributes[i];
      if(attribute.special)
        special_attribute_indexes.push(i);
    }
  }
  return special_attribute_indexes;
}

function productAttributeGet(attribute, product_value, product_id) {
  if(product_value === undefined)
    return;
  var filter_type = attribute.filter_type;
  switch(filter_type) {
  case 'B':
  case 'E':
    return attribute.values[product_value];
  case 'S':
    var values = [];
    for(var z = 0; z < product_value.length; z++)
      values.push(attribute.values[product_value[z]]);
    return values.join(', ');
  case 'N':
  case 'T':
    return product_value;
  default:
    throw new Error('Not handled filter type ' + filter_type);
  }
}

function cashbackCalc(price) {
  var tax;
  if(price <= 100)
    tax = 0;
  else if(price <= 5000)
    tax = 200;
  else if(price <= 10000)
    tax = 300;
  else if(price <= 15000)
    tax = 400;
  else if(price <= 20000)
    tax = 500;
  else
    tax = 600;
  return tax;
}

function productGet(product_id, raise_if_not_exists) {
  function donateCalc(price) {
    var tax;
    if(price <= 600)
      tax = 0.1;
    else if(price <= 1200)
      tax = 0.08;
    else if(price <= 3000)
      tax = 0.06;
    else if(price <= 10000)
      tax = 0.05;
    else if(price <= 25000)
      tax = 0.04;
    else
      tax = 0.03;
    return Math.ceil(price * tax);
  }

  function init() {
    var product = product_data.products[product_id];
    if(!product)
      return null;
    var names = product_data.product_field_names;
    var res = {product_id: +product_id};
    for(var i = 0; i < names.length; i++)
      res[names[i]] = product[i];
    var indexes = special_attribute_indexes_get(), product_value, attribute_value;
    for(var i = 0, l = indexes.length, index, attribute; i < l; i++) {
      index = indexes[i];
      attribute = product_data.attributes[index];
      product_value = res.attributes[index];
      attribute_value = productAttributeGet(attribute, product_value, product_id);
      if(attribute.special === 'instock')
        res[attribute.special] = product_value;
      else if(attribute.special === 'manufacturer_id') {
        res[attribute.special] = product_value;
        res.manufacturer = attribute_value;
        res.manufacturer_image = attribute.images[product_value];
      } else if(attribute.special === 'warranty')
        res[attribute.special] = attribute_value / 12;
      else if(attribute.special === 'label_new') {
        res[attribute.special] = product_value;
        res[attribute.special + '_text'] = res.special_date_end ? ui.lang.text_action_to + ' ' + res.special_date_end : attribute_value;
      } else
        res[attribute.special] = attribute_value;
    }
    res.discount = res.price_old ? res.price_old - res.saleprice : 0;
    res.donate = donateCalc(res.saleprice);
    res.cashback = cashbackCalc(res.saleprice);
    return res;
  }

  if(products_prepared[product_id] === undefined)
    products_prepared[product_id] = init();
  if(raise_if_not_exists && !products_prepared[product_id])
    throw new Error('Not exists product by id ' + product_id);
  return products_prepared[product_id];
}

function telephoneClean(tel) {
  tel = (tel + '').replaceAll('+38', '').replaceAll('+3', '');
  var res = '', ch;
  for(var i = 0; i < tel.length; i++) {
    ch = tel.charAt(i);
    if('0123456789'.indexOf(ch) !== -1)
      res += ch;
  }
  return res;
}

function telephoneFormat(tel) {
  tel = telephoneClean(tel);
  var res = '+38';
  var len = tel.length;
  if(len > 0)
    res += ' ' + tel.substring(0, 3);
  if(len > 3)
    res += ' ' + tel.substring(3, 6);
  if(len > 6)
    res += ' ' + tel.substring(6, 8);
  if(len > 8)
    res += ' ' + tel.substring(8);
  return res;
}

function warehousesGet(callback) {
  function loaded(request) {
    warehouses = JSON.parse(request.responseText);
    ui.settlements.settlement[settlementID][7] = warehouses;
    callback(warehouses);
  }

  var settlementID = ui.cartUI.shippingCityIDGet();
  if(!settlementID)
    return;
  var warehouses = ui.settlements.settlement[settlementID][7];
  if(warehouses)
    callback(warehouses);
  else
    ui.ajax('GET', '/data/np/w/' + settlementID + '.' + ui.langCode + '.json', null, loaded);
}

})();